import NotFoundGrid from './NotFoundGrid'

export default NotFoundGrid
